import { ApolloLink } from '@apollo/client'

const reportErrors = (errorCallback: (error: string) => void) =>
  new ApolloLink((operation, forward) => {
    const observable = forward(operation)
    observable.subscribe({ error: errorCallback })
    return observable
  })

export default reportErrors
